<template>
  <div :class="['search-hero', {'is_fixed': scroll_fix}]">
    <div class="search-hero__container">

	    <!-- CAROUSELS -->
			<div v-show="!scroll_fix" class="search-hero__carousels" :data-count="carousels.length">
				<div v-for="(carousel,c) in carousels" :key="`carousel_${c}`" class="search-hero__carousel">
					<h3 v-html="carousel.title" class="desktop"></h3>
					<h3 v-html="(carousel['short-title']) ?? carousel.title" class="mobile"></h3>
					<search-hero-carousel
            :facetRef="carousel.facet"
            :carousels_count="carousels.length"
            :type="type"
						:carousel_search_config="carousel.search_config">
          </search-hero-carousel>
				</div>
			</div>

			<form v-if="has_search || has_filter" :class="type" :action="`/search/${role}`" method="get" @submit.prevent="doSubmit">
	      <!-- SEARCH INPUT -->
				<template v-if="has_search">
					<div class="search-hero__search">
						<svg-magnify-glass class="search-hero__icon"></svg-magnify-glass>
						<input class="search-hero__input" v-model.trim="searchTerm" @input="doChange" :placeholder="placeholder"/>
						<button v-if="type == 'search'" type="submit" class="search-hero__button" aria-label="Search">
							<svg class="search-hero__button-icon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><defs/><path d="M3.807 11.1c1 1 2.216 1.5 3.646 1.5 1.43 0 2.645-.5 3.646-1.5 1.001-1.002 1.502-2.217 1.502-3.647 0-1.43-.5-2.645-1.502-3.646-1-1-2.216-1.501-3.646-1.501-1.43 0-2.645.5-3.646 1.501-1 1-1.501 2.216-1.501 3.646 0 1.43.5 2.645 1.501 3.646zm10.51 1.5L20 18.285 18.284 20l-5.683-5.684v-.911l-.322-.322c-1.358 1.18-2.967 1.77-4.826 1.77-2.073 0-3.843-.715-5.308-2.145C.715 11.278 0 9.526 0 7.453s.715-3.825 2.145-5.255C3.61.733 5.38 0 7.453 0s3.825.733 5.255 2.198c1.43 1.43 2.144 3.182 2.144 5.255 0 1.859-.59 3.468-1.769 4.826l.322.322h.911z" fill="#fff"/></svg>
							<span class="hidden md:block">Search</span>
						</button>
					</div>
	      </template>

				<!-- FACETS -->
				<div class="search-hero__facets">
					<template v-if="facets && type == 'filter'">
						<template v-for="(facet,f) in facets" :key="`facet_${f}`">
							<search-hero-facet :facetRef="facet"></search-hero-facet>
						</template>
					</template>
				</div>

				<!-- FILTER BUTTON -->
	      <template v-if="has_filter && type == 'filter'">
	      	<div class="search-hero__filters">
						<button class="search-hero__button" @click.prevent="emitter.emit('toggle:filter-bar')" aria-label="Filter">
							<svg class="search-hero__button-icon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16"><defs/><path d="M4 9.313V6.687h16v2.625H4zM0 0h24v2.688H0V0zm9.313 16v-2.688h5.374V16H9.314z" fill="#fff"/></svg>
							<span class="hidden md:block">More&nbsp;filters</span>
							<span v-if="filter_count" class="search-hero__button-count">{{ filter_count }}</span>
						</button>
					</div>
	      </template>
	    </form>
    </div>
  </div>
</template>

<script>
import SearchHeroFacet from './partials/SearchHeroFacet';
import SearchHeroCarousel from './partials/SearchHeroCarousel';

export default {

	components: {
		SearchHeroFacet,
		SearchHeroCarousel
	},

	props: {
    type: {
      type: String,
      default: 'search'
    },
		hero_config_string: {
			type: String,
			default: ''
		},
  },

  data() {
    return {
      searchTerm: '',
      scroll_fix: false,
      filter_count: false,
			carousels: [],
			has_search: false,
			has_filter: false,
			facets: false,
			hero_config: {},
    }
  },

  created() {
		if (this.hero_config_string !== '') {
			this.hero_config = JSON.parse(this.hero_config_string);

			this.carousels = this.hero_config.carousels;
			this.has_search = this.hero_config.search;
			this.has_filter = this.hero_config.more_filters;
			this.facets = (this.hero_config.facets) ? this.hero_config.facets.slice(0, 3) : false; // Max 3
		}

    this.emitter.on('update:filter_count',this.updateFilterCount);
		this.emitter.on('update:search-params',this.updateSearchParams);
		this.emitter.on('update:filter_items', this.updateFilterItems);

		if (this.type == "filter") {
			window.addEventListener("scroll", this.onScroll);
		}
	},

	beforeUnmount() {
    this.emitter.off('update:filter_count',this.updateFilterCount);
		this.emitter.off('update:search-params',this.updateSearchParams);
		this.emitter.off('update:filter_items', this.updateFilterItems);

		if (this.type == "filter") {
			window.removeEventListener("scroll", this.onScroll);
		}
		window.removeEventListener("resize", this.onResize);
	},

  methods: {
    onScroll(e) {
	    let mql = window.matchMedia('(max-width: 768px)');
			let windowTop = window.top.scrollY;
	    // console.log({windowTop});
	    let fix_point = (mql.matches) ? 580 : 410;
	    this.scroll_fix = (windowTop > fix_point);
	  },
		doSubmit() {
      if(this.searchTerm !== '') {
        let q = "query=" + this.searchTerm.replace("&", "~").replace("%", "¶").replace(",", "^");
        window.location = `/search/${this.role}?q=${encodeURIComponent(q)}`;
      }
    },
    doChange() {
    	if (this.type == 'filter') {
  			this.emitter.emit("update:search-term",this.searchTerm);
  		}
    },
    updateSearchParams(search_params) {
    	this.searchTerm = search_params.searchTerm;
    },
    updateFilterItems(filter_items) {
      this.filter_count = filter_items.length;
    }
  },

  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    placeholder() {
    	return 'Search';
    },
		role() {
			return (this.hero_config.search_config == undefined) ? 'jobs' : this.hero_config.search_config.role;
		}
  },
}
</script>
